import React from 'react'
import TrainingAllNotes from './TrainingAllNotes'

const TrainingNotesContainer = () => {
  return <TrainingAllNotes />
}

export default TrainingNotesContainer
